import {match} from 'ts-pattern';

import {mergeAll} from 'ramda';
import {isArray} from 'ramda-adjunct';

import {workshopRoutes} from '@dms/routes';
import {DmsDataGrid, queryParams, workshopSearchParams} from '@dms/shared';

import {composePath, noop, useNavigate} from 'shared/web';

import {SOURCE_DATA_GRID} from 'features/datagrid';
import type {ActionCallback, QueryFilterObject} from 'features/eag-grid';

const PREDEFINED_COLUMNS = ['state'] as const;

export function ServiceCaseOverview() {
  const navigate = useNavigate();

  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = ({
    actionKey,
    rowId,
    getColumnData,
    sourceSearchParams,
  }) => {
    const URLSourceSearchParams = new URLSearchParams(sourceSearchParams);

    const serviceCaseState = getColumnData<{key: string}>('state')?.value?.key;
    const serviceCaseId = isArray(rowId) ? rowId[0] : rowId;
    const path =
      serviceCaseState === 'DRAFT'
        ? composePath(workshopRoutes.draftServiceCase, {
            params: {id: serviceCaseId},
            queryParams: {
              tab: workshopSearchParams.create.serviceJobs,
              [SOURCE_DATA_GRID]: URLSourceSearchParams.get(SOURCE_DATA_GRID),
            },
          })
        : composePath(workshopRoutes.serviceCaseDetail, {
            params: {id: serviceCaseId},
            queryParams: {
              [queryParams.REDIRECT_SOURCE]: 'service-cases',
              [SOURCE_DATA_GRID]: URLSourceSearchParams.get(SOURCE_DATA_GRID),
            },
          });

    match(actionKey)
      .with('redirectDetail', 'detail', () => navigate(path))
      .with('redirectDetail_newTab', 'detail_newTab', () => window.open(path))
      .otherwise(noop);
  };

  const queryModifier = (filter: QueryFilterObject) => mergeAll([filter, {vehicleId: undefined}]);

  return (
    <DmsDataGrid
      data-testid="service-case-overview"
      gridCode="service-case-opensearch"
      actionCallback={actionCallback}
      predefinedColumns={PREDEFINED_COLUMNS}
      queryModifier={queryModifier}
    />
  );
}
